import { styledPolymorphic } from '@qred/components-library';

export const MainContainer = styledPolymorphic<
  'div',
  {
    $background?: React.CSSProperties['background'];
    $backgroundOpacity?: React.CSSProperties['opacity'];
    $backgroundColor?: React.CSSProperties['backgroundColor'];
  }
>()(
  (styled) => styled`
  display: flex;
  flex-direction: column;
  min-height: var(--client-height);
  font-size: 16px;

  ${({ $backgroundColor }) => {
    if ($backgroundColor) {
      return `
        background-color: ${$backgroundColor};
      `;
    }
    return '';
  }}

  ${({ $background, $backgroundOpacity }) => {
    if ($background && $backgroundOpacity) {
      return `
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
          background: ${$background};
          opacity: ${$backgroundOpacity};
        }
      `;
    } else if ($background) {
      return `
        background: ${$background};
      `;
    }
    return '';
  }}

  & > div {
    position: relative;
    z-index: 2;
  }
`
);

export const StepsContainer = styledPolymorphic<
  'div',
  {
    $justify?: React.CSSProperties['justifyContent'];
  }
>()(
  (styled) => styled`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.$justify ?? 'flex-start'};
  align-items: center;
  align-self: center;
  padding: 0 2em;
  width: 100%;
  padding: 0;
  height: calc(
    var(--client-height) - (var(--navbar-height) * 2)
  ); // total screen height - 2x navbar height

    ${({ theme }) =>
      `${theme.fn.largerThan('tablet')} {
          max-width: 40em;
          height: calc(
            var(--client-height) - (var(--navbar-height) * 4)
          ); // total screen height - 4x navbar height
          margin-top: 18px;
        }
      `}
      }
`
);

export const StandardStepContentFooter = styledPolymorphic<'div', {}>()(
  (styled) => styled`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border-top: 1px solid ${theme.fn.themeColor('Main/Grey/Alpha/OnLight/10%')};
  padding: 16px;
  background-color: ${theme.fn.themeColor('Container/Option_2_(White)')};
  text-align: center;
    
  ${theme.fn.largerThan('tablet')} {
    padding: 24px 32px;
    background-color: ${theme.fn.themeColor('Container/Option_4_(Grey)')};
  }

  button {
    align-self: center;
    }
 `}
`
);

export const StandardPageContainer = styledPolymorphic<'div', {}>()(
  (styled) => styled`
  ${({ theme }) => `
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 1; 
    height: var(--client-height);
    background-color: ${theme.fn.themeColor('Page/Option_1_(White)')};
    ${theme.fn.largerThan('tablet')} {
      padding-bottom: 60px;
      background-color: ${theme.fn.themeColor('Page/Option_2_(Green)')};
    }
  `}
`
);

export const StandardStepContent = styledPolymorphic<'div', {}>()(
  (_styled) => _styled`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  
  ${({ theme }) =>
    `
  background-color: ${theme.fn.themeColor('Page/Option_1_(White)')};
  ${theme.fn.largerThan('tablet')} {
      width: 40em; 
    }
  `}
`
);

export const StandardStepContentHeader = styledPolymorphic<'div', {}>()(
  (styled) => styled`
    padding: 24px 16px;

  ${({ theme }) =>
    `
    ${theme.fn.largerThan('tablet')} {
        padding: 32px;
      }
  `}
  `
);

export const StandardStepContentBody = styledPolymorphic<'div', {}>()(
  (styled) => styled`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  overflow: auto;
  padding: 24px 16px;

  ${({ theme }) =>
    `
    ${theme.fn.largerThan('tablet')} {
        padding: 32px;
      }
  `}
`
);

export const GoldenRatioContainer = styledPolymorphic<
  'div',
  { $grow?: boolean }
>()(
  (styled) => styled`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  &::before {
    content: '';
    flex: 0.382; /* Golden ratio - creates space above (38.2%) */
  }

  ${({ $grow }) =>
    $grow
      ? `
        > :last-of-type {
          flex: 1; /* Allows the last child to grow and fill the remaining space */
        }
      `
      : `
      &::after {
        content: '';
        flex: 0.618; /* Creates space below (61.8%) */
      }
      `}
    `
);
